import { Box, List, ListItem, Typography } from "@mui/material";
import type { FC } from "react";

export const ApprovalsModalContent: FC = () => {
  return (
    <Box>
      <Typography fontWeight={700} variant="body2">
        Stop chasing approvals across email and chat.
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        Today, reviews happen in Slack, Teams, or inboxes. Feedback gets missed, approvals get lost,
        and sometimes messages go out before they should—hurting trust and engagement.
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        Approval workflows bring that process into ChangeEngine.
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        With approvals, you can:
        <List sx={{ listStyleType: "disc", pl: 4 }}>
          <ListItem sx={{ display: "list-item" }}>
            Request and track approvals directly in the platform
          </ListItem>
          <ListItem sx={{ display: "list-item" }}>
            See exactly who has approved a message—and who hasn’t
          </ListItem>
          <ListItem sx={{ display: "list-item" }}>
            Prevent messages from being published until required approvals are complete
          </ListItem>
        </List>
      </Typography>
      <Typography variant="body2">
        Set smart rules so approvals are required only when they matter, for example:
        <List sx={{ listStyleType: "disc", pl: 4 }}>
          <ListItem sx={{ display: "list-item" }}>
            Messages sent to all staff or large segments
          </ListItem>
          <ListItem sx={{ display: "list-item" }}>
            Communications sent on behalf of executives, like the CEO
          </ListItem>
        </List>
      </Typography>
      <Typography variant="body2">
        At the same time, team leads can still message their own teams without unnecessary approval
        steps.
      </Typography>
      <Typography fontWeight={700} sx={{ mt: 2 }} variant="body2">
        Clear ownership. Fewer mistakes. No bottlenecks.
      </Typography>
    </Box>
  );
};
